export default __webpack_public_path__ + "static/media/star.11c78757.svg";